import React, { Component } from "react";
import {
    Alert,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    Table,
} from "react-bootstrap";
import moment from "moment";
import Card from "components/Card/Card.jsx";
import { fetchEmployeeLeaveBalanceRequest } from "api/employee";

class LeaveBalances extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: moment().year(),
            data: null,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        this.fetchBalance();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.employeeId !== this.props.employeeId) {
            this.fetchBalance();
        }
    }

    fetchBalance = () => {
        const { employeeId } = this.props;
        const { year } = this.state;
        if (!employeeId) {
            return;
        }

        this.setState({ loading: true, error: null });
        fetchEmployeeLeaveBalanceRequest(
            employeeId,
            year,
            (data) => this.setState({ data, loading: false, error: null }),
            (error) =>
                this.setState({
                    data: null,
                    loading: false,
                    error:
                        error.message ||
                        "Leave balances could not be loaded.",
                }),
        );
    };

    handleYearChange = (event) => {
        this.setState(
            { year: Number(event.target.value) },
            this.fetchBalance,
        );
    };

    render() {
        const { year, data, loading, error } = this.state;
        const currentYear = moment().year();
        const years = Array.from({ length: 6 }, (_, index) =>
            currentYear - index,
        );
        const balances = data && data.balances
            ? Object.values(data.balances)
            : [];
        const history = data && data.history ? data.history : [];

        return (
            <Col md={12}>
                <Card
                    title="Leave balances"
                    category="Approved requests are used; pending requests reserve days."
                    content={
                        <div>
                            <FormGroup className="leave-year-filter">
                                <ControlLabel>Balance year</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    value={year}
                                    onChange={this.handleYearChange}
                                >
                                    {years.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </FormControl>
                            </FormGroup>

                            {error && (
                                <Alert bsStyle="danger">{error}</Alert>
                            )}
                            {data &&
                                data.source &&
                                !data.source.payLevelConfigured && (
                                    <Alert bsStyle="warning">
                                        Sick and vacation leave allowances
                                        have not been configured for this
                                        employee&apos;s pay level.
                                    </Alert>
                                )}

                            {loading ? (
                                <div className="loader" />
                            ) : (
                                <div>
                                    <div className="leave-balance-grid">
                                        {balances.map((balance) => (
                                            <div
                                                className="leave-balance-panel"
                                                key={balance.leaveType}
                                            >
                                                <div className="leave-balance-panel__heading">
                                                    <strong>
                                                        {balance.label}
                                                    </strong>
                                                    <span>
                                                        Pays out{" "}
                                                        {
                                                            balance.payoutSchedule
                                                        }
                                                    </span>
                                                    <span>
                                                        {data.source &&
                                                        data.source
                                                            .eligibleMonths ===
                                                            0
                                                            ? "Not eligible this year"
                                                            : `${balance.monthlyEntitlement} days/month${
                                                                  data.source &&
                                                                  data.source
                                                                      .isProrated
                                                                      ? ` from ${moment()
                                                                            .month(
                                                                                data
                                                                                    .source
                                                                                    .accrualStartMonth -
                                                                                    1,
                                                                            )
                                                                            .format(
                                                                                "MMMM",
                                                                            )} (${data.source.eligibleMonths} months)`
                                                                      : ""
                                                              }`}
                                                    </span>
                                                </div>
                                                <div className="leave-balance-panel__numbers">
                                                    <span>
                                                        <b>
                                                            {balance.initial}
                                                        </b>
                                                        Initial
                                                    </span>
                                                    <span>
                                                        <b>{balance.used}</b>
                                                        Used
                                                    </span>
                                                    <span>
                                                        <b>
                                                            {
                                                                balance.remaining
                                                            }
                                                        </b>
                                                        Left
                                                    </span>
                                                    <span>
                                                        <b>
                                                            {
                                                                balance.availableToRequest
                                                            }
                                                        </b>
                                                        Available now
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <h4 className="leave-history-title">
                                        {year} leave history
                                    </h4>
                                    <Table responsive hover>
                                        <thead>
                                            <tr>
                                                <th>Leave type</th>
                                                <th>Dates</th>
                                                <th>Paid</th>
                                                <th>Without pay</th>
                                                <th>Status</th>
                                                <th>Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {history.length ? (
                                                history.map((entry) => (
                                                    <tr key={entry._id}>
                                                        <td>
                                                            {
                                                                entry.leaveTypeLabel
                                                            }
                                                        </td>
                                                        <td>
                                                            {moment(
                                                                entry.startDate,
                                                            ).format(
                                                                "MM/DD/YYYY",
                                                            )}
                                                            {" - "}
                                                            {moment(
                                                                entry.endDate,
                                                            ).format(
                                                                "MM/DD/YYYY",
                                                            )}
                                                        </td>
                                                        <td>
                                                            {entry.paidDays}
                                                        </td>
                                                        <td>
                                                            {
                                                                entry.withoutPayDays
                                                            }
                                                        </td>
                                                        <td>
                                                            <span
                                                                className={`leave-status leave-status--${String(
                                                                    entry.status,
                                                                ).toLowerCase()}`}
                                                            >
                                                                {entry.status}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {entry.reason || "-"}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6">
                                                        No paid leave requests
                                                        were recorded for this
                                                        year.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </div>
                    }
                />
            </Col>
        );
    }
}

export default LeaveBalances;
